// import zdjęć
import zdj0 from '../assets/kwiaty/0.jpg'
import zdj1 from '../assets/kwiaty/1.jpg'
import zdj2 from '../assets/kwiaty/2.jpg'
import zdj3 from '../assets/kwiaty/3.jpg'
import zdj4 from '../assets/kwiaty/4.jpg'
import zdj5 from '../assets/kwiaty/5.jpg'
import zdj6 from '../assets/kwiaty/6.jpg'
import zdj7 from '../assets/kwiaty/7.jpg'
import zdj8 from '../assets/kwiaty/8.jpg'
import zdj9 from '../assets/kwiaty/9.jpg'
import zdj10 from '../assets/kwiaty/10.jpg'
import zdj11 from '../assets/kwiaty/11.jpg'
import zdj12 from '../assets/kwiaty/12.jpg'
import zdj13 from '../assets/kwiaty/13.jpg'
import zdj14 from '../assets/kwiaty/14.jpg'
import zdj15 from '../assets/kwiaty/15.jpg'
import zdj16 from '../assets/kwiaty/16.jpg'
import zdj17 from '../assets/kwiaty/17.jpg'
import zdj18 from '../assets/kwiaty/18.jpg'
import zdj19 from '../assets/kwiaty/19.jpg'
import zdj20 from '../assets/kwiaty/20.jpg'
import zdj21 from '../assets/kwiaty/21.jpg'
import zdj22 from '../assets/kwiaty/22.jpg'
import zdj23 from '../assets/kwiaty/23.jpg'
import zdj24 from '../assets/kwiaty/24.jpg'
import zdj25 from '../assets/kwiaty/25.jpg'
import zdj26 from '../assets/kwiaty/26.jpg'
import zdj27 from '../assets/kwiaty/26.jpg'
import zdj28 from '../assets/kwiaty/28.jpg'
import zdj29 from '../assets/kwiaty/29.jpg'


// tablica zmiennych
let pictures = [
    zdj0,
    zdj1,
    zdj2,
    zdj3,
    zdj4,
    zdj5,
    zdj6,
    zdj7,
    zdj8,
    zdj9,
    zdj10,
    zdj11,
    zdj12,
    zdj13,
    zdj14,
    zdj15,
    zdj16,
    zdj17,
    zdj18,
    zdj19,
    zdj20,
    zdj21,
    zdj22,
    zdj23,
    zdj24,
    zdj25,
    zdj26,
    zdj27,
    zdj28,
    zdj29,
];

export default pictures; 
  
  